var exports = {
  "oN": "ComposerInline.module__customEmoji___aWZNNk",
  "wh": "ComposerInline.module__plainText___aWZNNk",
  "eu": "ComposerInline.module__literal___aWZNNk",
  "p6": "ComposerInline.module__spoiler___aWZNNk",
  "sM": "ComposerInline.module__srOnly___aWZNNk",
};

module.exports = exports;
